import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['list', 'listIcon', 'selector'];
  static requiredTargets = [];

  static classes = ['toggleList', 'toggleListIcon'];
  static requiredClasses = [];

  static values = {
    selectorIndex: Number
  };

  // TARGETS
  declare listIconTarget: SVGElement;
  declare listTarget: HTMLDivElement;
  declare readonly hasListIconTarget: boolean;
  declare readonly hasListTarget: boolean;
  declare readonly hasSelectorTarget: boolean;
  declare selectorTarget: HTMLSelectElement;

  // CLASSES
  declare toggleListClass: string;
  declare toggleListIconClass: string;

  // VALUES
  declare selectorIndexValue: number;

  closeList(event) {
    if (this.hasListTarget && this.listTarget.contains(event.relatedTarget)) {
      event.relatedTarget.click();
    }

    this.toggleList();
  }

  connect() {
    const selectorVal = this.getSelectorIndexValue();

    if (selectorVal !== false) {
      this.selectorIndexValue = selectorVal;
    }
  }

  getSelectorIndexValue(): number | false {
    if (!this.hasSelectorTarget) {
      return false;
    }

    return this.selectorTarget.options.selectedIndex;
  }

  handleSelector() {
    const selectedIndex = this.getSelectorIndexValue();

    if (selectedIndex !== false) {
      this.openInNewTab(this.selectorTarget.options[selectedIndex].value);
      this.selectorTarget.options.selectedIndex = this.selectorIndexValue;
    }
  }

  openInNewTab(url: string) {
    window.open(url, '_blank', 'noopener, noreferrer');
  }

  toggleList() {
    if (this.hasListTarget) {
      this.listTarget.classList.toggle(this.toggleListClass);
    }

    if (this.hasListIconTarget) {
      this.listIconTarget.classList.toggle(this.toggleListIconClass);
    }
  }
}
